import shopifyPlusBrandsJson from "../../data/shopifyPlusBrands.json";
import { Link } from "react-router-dom";
import CmsSlider from "../../componets/CmsSlider";

export default function Section10() {
    const brandsData = shopifyPlusBrandsJson;

    const settings = {
        touchMove: false,
        arrows: false,
        dots: true,
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: false,
        cssEase: "linear",
        responsive: [
            {
                breakpoint: 992,
                settings: { slidesToShow: 4, slidesToScroll: 1, touchMove: true, infinite: true },
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 3, slidesToScroll: 1, touchMove: true, infinite: true },
            },
        ],
    };

    return (
        <div className="w-full Section9">
            <div className="w-full section9-container">
                <div className="w-[90%] md:w-[80%] pb-[1%] mx-auto text-center">
                    <h2 className="leading-[29px] md:leading-[41px] text-[24px] md:text-[34px] text-[#151515] font-bold my-[0.67em]">
                        Brands That Choose Us
                    </h2>
                    <p className="leading-[20px] text-[#373737] text-base font-open w-full md:w-[71%] mx-auto">
                        Our experience over the past 7 years encompasses a portfolio of 500+
                        website projects.
                    </p>
                </div>

                <div className="w-full pt-[35px] pb-[60px] px-0 md:px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[80%]">
                    <CmsSlider settings={settings} slides={brandsData} />
                </div>

                <div className="text-center">
                    <Link
                        to="/clients"
                        className="inline-block cursor-pointer rounded-[3px] py-[10px] px-[15px] bg-[#DA2128] text-white border-none font-bold"
                    >
                        View Portfolio
                    </Link>
                </div>
            </div>

            <div className="line my-[55px] md:my-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
        </div>
    );
}
